import { render, staticRenderFns } from "./Masuk.vue?vue&type=template&id=d06654f2&"
import script from "./Masuk.vue?vue&type=script&lang=js&"
export * from "./Masuk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports